export const SET_ACADEMIC_SECTIONS = 'SET_ACADEMIC_SECTIONS';
export const SET_ACADEMIC_SECTION = 'SET_ACADEMIC_SECTION';